import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const Wrapper = styled(FlexRow)`
  width: 100%;
  height: 100%;
  align-items: center;
`;

export const LeftColumn = styled(FlexColumn)`
  padding: 32px 48px;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  ${QUERIES.largeTabletAndUp} {
    width: 336px;
    align-items: start;
    flex-shrink: 0;
  }
`;

export const RightColumn = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  display: none;
  ${QUERIES.largeTabletAndUp} {
    display: flex;
  }
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
  width: 540px;
`;
